module.exports = __webpack_public_path__ + "media/images/flag/ch-4144acec2c25bbd2bd42caaf95b6e11b.jpg";